import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class InstallPatchesActionValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = true;
  protected canRunOnCompanionRecords = false;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (!ProtectedEntitiesHelper.isComputer(record)) {
      return true;
    }

    if (!record.specifics.isManaged) {
      return false;
    }

    if (record.specifics.serverHasNsxIntegration) {
      return false;
    }

    if (ProtectedEntitiesHelper.isManagedByHviAndNotIsBest(record)) {
      return false;
    }

    if (!ProtectedEntitiesHelper.isUnifiedClient(record)) {
      return false;
    }

    if (!record.specifics.hasPatchManagement) {
      return false;
    }

    return true;
  }
}
